import React from 'react';
import { css } from 'aphrodite';
import styles from './map-styles';
import GoogleMapReact from 'google-map-react';

const key = `${process.env.REACT_APP_API_URL === 'http://localhost:1337/' ? 'AIzaSyDADEQ0bhpw0KeNSKEliE1oO6o6aYSTrXc' : 'AIzaSyDIEJ7oDdmduVB97kqK6yGT2u5KvxbJQf4'}`;

const Map = (props) => (
  <div className={css(styles.root)}>

    <GoogleMapReact
      bootstrapURLKeys={{ key: key }}
      defaultCenter={props.center || {lat: 51.509865, lng: -0.118092}}
      defaultZoom={props.zoom || 11}
    >

      {props.children}

    </GoogleMapReact>

  </div>
);

export default Map;


// WEBPACK FOOTER //
// ./src/components/map/map.js